module.exports = __webpack_public_path__ + "static/media/stage-locked.db37bd82.png";